<template>
  <div class="top">
    <Header />
  </div>
  <div class="content-container">
    <router-view />
  </div>
  <Footer />
</template>

<script>
import Header from "./components/HeaderView.vue";
import Footer from "./components/FooterView.vue";

export default {
  components: {
    Header,
    Footer,
  },
};
</script>

<style>
html,
body {
  margin: 0;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.top {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
}

.content-container {
  max-width: 100%;
  padding-top: 190px;
}

/* 모바일 세로 (해상도 ~ 479px)*/
@media all and (max-width: 479px) {
  .content-container {
    max-width: 100%;
    padding-top: 100px;
  }
}
</style>
